import { frontendURL } from '../../../helper/URLHelper';
import PaymentsIndex from './pages/PaymentsIndex.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/payments'),
    component: PaymentsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'payments_dashboard_index',
        component: PaymentsIndex,
        meta: commonMeta,
      },
    ],
  },
];
